<template>
    <div class="m-viewport" ref="view">
        <div class="shop-main-view">
            <transition name="fade" mode="out-in" appear>
                <router-view v-if="ready && isRouterAlive" :shop_offer="shop_offer"></router-view>
            </transition>
        </div>

        
        <div class="shop-nav">
          <router-link 
          v-for="(item,index) in router_mainfest" 
          :key = index
          v-bind:to="item.link" 
          class="u-nav"
          :class="item.name" 
          active-class="active">
          {{item.title}}
          </router-link>         
        </div>
    </div>
</template>

<style>
@import '../../assets/css/common.m.css';

.m-viewport{
    position: relative;
    width: 750px;
    min-height: 100vh;
    margin: 0 auto 0;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
    font-size: 24px;
    background-color: #341e0d;
    color: #fff;
    overflow-x: hidden;
    /* overflow-y: scroll;    */
}

.shop-view{
    padding-bottom: 250px;
}

/* nav */
.shop-nav {
    display: flex;
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 20;
    transform: translateX(-50%);    
    width: 750px;
    height: 130px;
    padding: 0 10px 8px;
    justify-content: space-between;
    align-items: flex-end;
    background-image: url(~@/assets/images/bg-nav.png);
    box-sizing: border-box;
}

.pc .shop-nav{
    margin-left: -7px;
}

.shop-nav .u-nav {
    width: 150px;
    height: 77px;
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/nav/nav-1.png);
}

/* TODO */
.shop-nav .bazaar {
    background-image: url(~@/assets/images/nav/nav-1.png);
}

.shop-nav .bazaar.active {
    background-image: url(~@/assets/images/nav/nav-1-act.png);
}

.shop-nav .task.active {
    background-image: url(~@/assets/images/nav/nav-2-act.png);
}

.shop-nav .task {
    background-image: url(~@/assets/images/nav/nav-2.png);
}

.shop-nav .basket.active {
    background-image: url(~@/assets/images/nav/nav-3-act.png);
}

.shop-nav .basket {
    background-image: url(~@/assets/images/nav/nav-3.png);
}

.shop-nav .order.active {
    background-image: url(~@/assets/images/nav/nav-4-act.png);
}

.shop-nav .order {
    background-image: url(~@/assets/images/nav/nav-4.png);
}

.shop-nav .ex.active {
    background-image: url(~@/assets/images/nav/nav-5-act.png);
}

.shop-nav .ex {
    background-image: url(~@/assets/images/nav/nav-5.png);
}

</style>

<script>
export default {
    data() {
        return {
            isRouterAlive : true,
            router_mainfest : [
                {name : 'bazaar',title : '集市',link : '/bazaar'},
                {name : 'task',title : '领福利',link : '/task'},
                {name : 'basket',title : '金算盘',link : '/basket'},
                {name : 'order',title : '账簿',link : '/order'},
                {name : 'ex',title : '双12专享',link : '/ex'},
            ],
        }
    },
    provide () {
        return {
            reload: this.reload
        }
    },    
    props : {
        ready : {
            default : false,
        },
        shop_offer :{
            default : [],
        },
    },
    methods: {
        reload () {
            this.isRouterAlive = false
            this.$nextTick(function () {
            this.isRouterAlive = true
            })
        }
    }        
}
</script>


// WEBPACK FOOTER //
// src/pages/index/index.vue